import { BehaviorSubject } from "rxjs";

export const invalidSymbols$ = new BehaviorSubject<string>('');
